import React, { useState } from "react";
import { useSelector/*, useDispatch*/ } from "react-redux";
import { Button } from "@material-ui/core";
import { ModalMotivoBaja } from "./ModalMotivoBaja";
import {
  //imprimirPDFSolicitud,
  //repetirSolicitudEmp
} from "../../../../actions/empadronamiento/Empadronamiento";
import { EMPADRONAMIENTO_SOLICITUDES_ESTADOS, EMPADRONAMIENTO_TIPOS_NOTAS } from "../../../../utils/constants";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { EMPADRONAMIENTO_MENU_PERMISOS } from "../../../../utils/permisos";
import { ModalMotivoRechazo } from "./ModalMotivoRechazo";
import { ModalMotivoFin } from "./ModalMotivoFin";
import { ModalMotivoAutorizacion } from "./ModalMotivoAutorizacion";
import { ModalAgregarAlerta } from "./ModalAgregarAlerta";
import { ModalNotasEmpadronamiento } from "./ModalNotasEmpadronamiento";
import { ModalFechaFinEmpadronamiento } from "./ModalFechaFinEmpadronamiento";

export const AdministrarMenu = (props) => {
  //const dispatch = useDispatch();

  const { solicitudSeleccionada = {} } = useSelector(
    (state) => state.empadronamiento
  );
  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [openModalMotivoBaja, setOpenModalMotivoBaja] = useState(false);
  const [openModalMotivoRechazo, setOpenModalMotivoRechazo] = useState(false);
  const [openModalMotivoFin, setOpenModalMotivoFin] = useState(false);
  //const [openModalMotivoDevolucion, setOpenModalMotivoDevolucion] = useState(false);
  const [openModalAutorizaSolicitud, setOpenModalAutorizaSolicitud] = useState(false);
  const [openModalAlerta, setOpenModalAlerta] = useState(false);

  const [motivoBaja, setMotivoBaja] = useState("");
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [motivoFin, setMotivoFin] = useState("");
  //const [motivoDevolucion, setMotivoDevolucion] = useState("");
  const [motivoAutorizacion, setMotivoAutorizacion] = useState("");
  const [openModalNotas, setOpenModalNotas] = useState(false);
  const [idTipoNota, setIdTipoNota] = useState(null);
  const [openModalFechaFin, setOpenModalFechaFin] = useState(false);

  const esAuditorCeiba = validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );
  const esAuditorOspe = validarSoloUnPermiso(
    permisosUser,
    EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  );

  /*
  const onClickEnviarMail = () => {
    dispatch(enviarPDFSolicitud(solicitudSeleccionada.idSolicitud));
  };
  */

  const onClickRetomar = () => {
    //setOpenModalGestionar(true);
    //dispatch(setReceta(item));
    props.postRetomarSolicitud(solicitudSeleccionada);
  };

  const onClickRevisar = () => {
    props.postAutorizarSolicitud(solicitudSeleccionada);
  };
  const onClickAutorizar = () => {
    //setOpenModalGestionar(true);
    //dispatch(setReceta(item));
    //props.postAutorizarSolicitud(solicitudSeleccionada);

    //setOpenModalAutorizaSolicitud(true);
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.AUTORIZACION);
  };

  /*
  const onClickRepetir = () => {
    dispatch(repetirSolicitudEmp(solicitudSeleccionada, props.postRetomarSolicitud));
  };
   const onClickReimprimir = () => {
     dispatch(imprimirPDFSolicitud(solicitudSeleccionada.idSolicitud));
   };
   */
  const onClickAnular = () => {
    //setOpenModalMotivoRechazo(true);
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.ANULACION);
  };

  const onClickRechazar = () => {
    //setOpenModalMotivoRechazo(true);
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.RECHAZO);
  };

  const onClickFinalizar = () => {
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.FINALIZACION);
    //setOpenModalMotivoFin(true);
  };

  const onClickEnFechaFin = () => {
    setOpenModalFechaFin(true);
    //setOpenModalMotivoFin(true);
  };

  const onClickDevolver = () => {
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.DEVOLUCION);
  };
  const onClickAlerta = () => {
    setOpenModalAlerta(true);
  };

  console.log("solicitudSeleccionada?.idUsuarioTomada", solicitudSeleccionada?.idUsuarioTomada);

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >
        {openModalNotas &&
          <ModalNotasEmpadronamiento
            open={openModalNotas}
            close={() => {
              setOpenModalNotas(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            disabled={solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA ?
              false : props.disabled}
            titulo={"Agregar Nota"}
            nota={null}
            tipoNotaDisabled={true}
            tipoNota={idTipoNota}
            setOpenModalGestionar={props.setOpenModalGestionar}
            idEstadoSolicitud={solicitudSeleccionada?.idEstadoSolicitud}
          />

        }
        {openModalMotivoBaja && (
          <ModalMotivoBaja
            open={openModalMotivoBaja}
            close={() => {
              setOpenModalMotivoBaja(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            titulo={"Motivo de Anulación"}
            motivoBaja={motivoBaja}
            setMotivoBaja={setMotivoBaja}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {openModalMotivoRechazo && (
          <ModalMotivoRechazo
            open={openModalMotivoRechazo}
            close={() => {
              setOpenModalMotivoRechazo(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            titulo={"Motivo de Rechazo"}
            motivoRechazo={motivoRechazo}
            setMotivoRechazo={setMotivoRechazo}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {openModalMotivoFin && (
          <ModalMotivoFin
            open={openModalMotivoFin}
            close={() => {
              setOpenModalMotivoFin(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            titulo={"Motivo de Fin"}
            motivoFin={motivoFin}
            setMotivoFin={setMotivoFin}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {openModalAutorizaSolicitud && (
          <ModalMotivoAutorizacion
            open={openModalAutorizaSolicitud}
            close={() => {
              setOpenModalAutorizaSolicitud(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            titulo={"Nota de autorizacion"}
            motivoAutorizacion={motivoAutorizacion}
            setMotivoAutorizacion={setMotivoAutorizacion}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {openModalAlerta && (
          <ModalAgregarAlerta
            open={openModalAlerta}
            close={() => {
              setOpenModalAlerta(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            alertas={solicitudSeleccionada?.alertas}
            titulo={"Alertas"}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {openModalFechaFin &&
          <ModalFechaFinEmpadronamiento
            open={openModalFechaFin}
            close={() => {
              setOpenModalFechaFin(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            disabled={false}
            titulo={"Actualizar Fecha Fin"}
            fechaFin={solicitudSeleccionada.fechaFin}
          />
        }
        {/*solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "orange",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickReimprimir()
            }
          >
            Imprimir
          </Button>)*/}
        {/*solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA
          && (solicitudSeleccionada?.fechaFin !== null
            && new Date(solicitudSeleccionada?.fechaFin) >= new Date())
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickEnviarMail()
            }
          >
            Enviar por mail
          </Button>)*/}
        {/*solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA &&
          (solicitudSeleccionada?.fechaFin !== null
            && new Date(solicitudSeleccionada?.fechaFin) < new Date())
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "blue",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRepetir()
            }
          >
            Repetir
          </Button>)*/}
        {solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.EN_CARGA
          && !esAuditorCeiba
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "purple",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRetomar()
            }
          >
            Retomar
          </Button>)}
        {solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
          && validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          )
          && !esAuditorCeiba
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRevisar()
            }
          >
            Autorizar
          </Button>)}
        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION
          && esAuditorCeiba) ||
          (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
            && esAuditorOspe))
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: esAuditorCeiba ? "green" : "lightblue",
              color: esAuditorCeiba ? "white" : "black",
            }}
            variant="contained"
            onClick={() =>
              onClickAutorizar()
            }
          >
            {esAuditorCeiba ? "Autorizar" : "Enviar a mandataria"}
          </Button>)}
        {/* {solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
          && validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          )
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "lightblue",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickAutorizar()
            }
          >
            {validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ) ? "Autorizar" : "Revisar"}
          </Button>)} */}
        {/*(solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION
          || solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
          || solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.EN_CARGA)
          && solicitudSeleccionada?.idUsuarioTomada > 0
          && solicitudSeleccionada?.idUsuarioTomada !== idUsuario
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "pink",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickLiberar()
            }
          >
            Liberar
          </Button>)*/}

        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION
          && (validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ))) ||
          (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
            && (validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ))))
          &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "red",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRechazar()
            }
          >
            Rechazar
          </Button>}

        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION
          && (validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ))) ||
          (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
            && (validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ))) ||
          solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.EN_CARGA)
          &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "black",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickAnular()
            }
          >
            Anular
          </Button>}

        {solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA
          && !esAuditorCeiba
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "black",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickFinalizar()
            }
          >
            Finalizar
          </Button>)}

        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
          && !esAuditorCeiba)
          || (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION
            && esAuditorCeiba)
        ) &&
          (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "darkblue",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickEnFechaFin()
            }
          >
            Actualizar Fecha Fin
          </Button>)}
        {(solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION ||
          solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION)
          &&
          ((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION
            && (validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ))) ||
            (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
              && (validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
              ))))
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "yellow",
              color: "black",
            }}
            variant="contained"
            onClick={() =>
              onClickDevolver()
            }
          >
            Devolver
          </Button>)}
        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION
          && esAuditorOspe) ||
          ((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA &&
            solicitudSeleccionada?.fechaFin !== null
            && new Date(solicitudSeleccionada?.fechaFin) > new Date())
            && (esAuditorOspe || esAuditorCeiba)) ||
          (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION
            && esAuditorCeiba)
        ) &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
            }}
            variant="contained"
            onClick={() =>
              onClickAlerta()
            }
            color="primary"
          >
            Agregar Alerta
          </Button>}
      </div>
    </React.Fragment>
  );
};